import {Input} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import type {DoorCodeInputProps} from './DoorCodeInput.types'

export function DoorCodeInput({name, 'data-testid': dataTestId}: DoorCodeInputProps): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => (
        <Input
          autoCapitalize="none"
          autoComplete="__disable-autocomplete"
          data-testid={dataTestId}
          error={fieldState.invalid}
          helperText={fieldState.error?.message}
          label={t('cargo.create.address.door_code', 'Домофон')}
          name={name}
          onBlur={field.onBlur}
          onChange={field.onChange}
          size="l"
          spellCheck="false"
          value={field.value?.toString()}
          variant="line"
        />
      )}
    />
  )
}
